import { createSelector } from 'reselect';
import { isNil } from 'lodash';

import { selectUserProfile } from '../UserProfile/selectors';
import { IUserProfileState } from '../UserProfile/reducer';

export const getAuthToken = createSelector(
  selectUserProfile,
  (userProfile: IUserProfileState) => {
    if (userProfile.userInfo) {
      return userProfile.userInfo.token;
    } else {
      return null;
    }
  },
);

export const getIsLoggedIn = createSelector(
  getAuthToken,
  (token?: string | null) => {
    return !isNil(token);
  },
);

export const makeGetGlobalAuthFormErrors = (formName: string) => {
  return createSelector(
    (state: any) => {
      return state.auth.globalAuthFormErrors;
    },
    globalAuthFormErrors => {
      return globalAuthFormErrors[formName];
    },
  );
};



// WEBPACK FOOTER //
// ./src/containers/Auth/selectors.ts